"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18N = void 0;
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var PermissionRevoked_1 = __importDefault(require("../../../Icons/Notifications/PermissionRevoked"));
var AccessRestrictedIcon_1 = __importDefault(require("../../../Icons/Notifications/AccessRestrictedIcon"));
var utils_1 = require("../../utils");
exports.i18N = {
    en: {
        title: 'World Permission Revoked',
        accessTitle: 'World Access Revoked',
        access: 'You have been revoked the permission to access World {world}',
        deployment: 'The owner of the World {world} has revoked your permission to deploy in their world',
        streaming: 'The owner of the World {world} has revoked your permission to stream in their world'
    },
    es: {
        title: 'Permiso para mundo revocado',
        accessTitle: 'Acceso a Mundo revocado',
        access: 'Te han removido el permiso para acceder al mundo {world}',
        deployment: 'El propietario del mundo {world} ha revocado tu permiso para deployar en su mundo',
        streaming: 'El propietario del mundo {world} ha revocado tu permiso para transmitir en su mundo'
    },
    zh: {
        title: '世界许可被撤销',
        accessTitle: '世界访问被撤销',
        access: '您已被撤销访问世界{workd}的许可',
        deployment: '世界所有者{world}已撤销您在其世界中部署的许可',
        streaming: '世界的所有者{world}已撤销了您在世界上流媒体的允许'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var WorldsPermissionRevokedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    var permission = notification.metadata.permissions[0];
    var isAccessNotification = permission === 'access';
    var Icon = isAccessNotification ? AccessRestrictedIcon_1.default : PermissionRevoked_1.default;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(Icon, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, isAccessNotification ? exports.i18N[locale].accessTitle : exports.i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, (0, utils_1.replaceWithValues)(exports.i18N[locale][permission], {
            world: react_1.default.createElement("strong", null, notification.metadata.world)
        }))));
};
exports.default = WorldsPermissionRevokedNotification;
